import { Action } from '@ngrx/store';

export enum CandidateUploadActionTypes {
  GetCandidateByEmail = '[Candidate Upload/Assign Popup] Get by email',
  UploadCandidatesSelect = '[Candidate Upload/Assign Popup] Select',
  GetCandidateByEmailFailure = '[Candidate Upload/Assign Popup] Get by email failure',
  Upload = '[Candidate Upload/Assign Popup] Upload resume',
  UploadSuccess = '[Candidate Upload/Assign Popup] Upload resume success',
  UploadFailure = '[Candidate Upload/Assign Popup] Upload resume failure'
}

export class CandidatesUploadGet implements Action {
  readonly type = CandidateUploadActionTypes.GetCandidateByEmail;

  constructor(public payload: { emailId: string }) {}
}

export class CandidatesUploadSelect implements Action {
  readonly type = CandidateUploadActionTypes.UploadCandidatesSelect;

  constructor(public payload?: number) {}
}

export class CandidatesUploadGetFail implements Action {
  readonly type = CandidateUploadActionTypes.GetCandidateByEmailFailure;

  constructor(public payload?: any) {}
}

export class UploadResume implements Action {
  readonly type = CandidateUploadActionTypes.Upload;

  constructor(public payload: { file: any; id: number }) {}
}
export class UploadResumeSuccess implements Action {
  readonly type = CandidateUploadActionTypes.UploadSuccess;

  constructor(public payload?: any) {}
}
export class UploadResumeFailure implements Action {
  readonly type = CandidateUploadActionTypes.UploadFailure;

  constructor(public payload?: any) {}
}

export type CandidateUploadActionsUnion =
  | CandidatesUploadGet
  | CandidatesUploadSelect
  | CandidatesUploadGetFail
  | UploadResume
  | UploadResumeSuccess
  | UploadResumeFailure;
